import type { PaymentResponseData, ResultCode } from "@adyen/adyen-web";
import { Logger, LogTag, ServiceType } from "@lib/monitoring/logger";

export interface AdyenRefusalResponse {
    refusalReason: string;
    refusalReasonCode: string;
    resultCode: ResultCode;
}

export const parsePaymentResult = (result: string) => {
    try {
        return JSON.parse(result) as PaymentResponseData | AdyenRefusalResponse;
    } catch (error) {
        Logger.error(ServiceType.ADYEN, "Error during parsing Adyen payment result", {
            error,
            tag: LogTag.CHECKOUT,
        });
        throw error;
    }
};
